import { Box, Stack, Switch, Typography } from '@mui/material';
import { toggleRowStyles } from '@pages/CustomPoiTypes.styles';

interface Props {
  label: string;
  /**
   * One sentence on what turning this on actually does on the device. Optional because a
   * previewed field carries whatever help its author wrote, which is often nothing.
   */
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/** A single on/off option, with room for the sentence that explains it. */
const ToggleRow: React.FC<Props> = ({ label, description, checked, onChange, disabled }) => (
  <Stack direction="row" sx={toggleRowStyles}>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>{label}</Typography>
      {description && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
          {description}
        </Typography>
      )}
    </Box>
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={(_event, value) => onChange(value)}
      sx={{ flexShrink: 0 }}
    />
  </Stack>
);

export default ToggleRow;
